import styled from '@emotion/styled';

import {
  blueBlack400,
  blueBlack650,
  blueBlack700,
} from '../../theme/videa-style-tokens';

export const ProcessingHistoricalContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  width: 100vw;
  height: 100vh;
  box-sizing: border-box;
  position: absolute;
  top: 0;
  left: 0;
  background-color: black;
  color: ${blueBlack400};
  border-bottom: 0.05em solid ${blueBlack700};

  .status {
    width: 100%;
    background-color: rgba(55, 111, 255, 0.25);
    box-shadow: inset 0 0 0.5em rgba(0, 0, 0, 0.75);
    border-radius: 0.5em;
    margin: 1em 0;
    overflow: hidden;
    display: flex;
    flex-direction: row;
    align-items: center;
    padding-left: 1em;

    &.loading {
      padding-left: 0;
      flex-direction: column;
    }
    .Mui-SvgIcon-root {
      margin-left: 1em;
    }

    .MuiLinearProgress-root {
      width: 100%;
      height: 2em;
    }
  }

  .message {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    box-sizing: border-box;
    padding: 3em 5em;
    width: 67vw;
    height: 20em;
    min-width: 40em;
    background-color: ${blueBlack700};
    border-radius: 1.5em;
    position: relative;

    .text {
      display: flex;
      font-family: 'Neue Haas Grotesk Display Pro', sans-serif;
      align-items: center;
      justify-content: flex-start;
      box-sizing: border-box;
      font-size: 1.5em;
      font-weight: 500;
      color: white;
      padding: 1em;
      gap: 1em;
    }
    .title {
      font-family: 'Neue Haas Grotesk Display Pro', sans-serif;
      font-size: 1.625em;
    }
    .back-button {
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 0.5em;
      padding: 1.5em 0.75em;
      color: white;
      font-size: 1em;
      border-radius: 0.5em;
      text-decoration: none;

      &:hover {
        background-color: ${blueBlack650};
        cursor: pointer;
      }
    }
    .close-button {
      display: flex;
      position: absolute;
      top: 1em;
      right: 1em;
      background-color: ${blueBlack650};

      .MuiSvgIcon-root {
        fill: white;
      }
    }
  }
`;
